async function get_user_sentForReview_true() {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + sessionStorage.getItem("token"),
    },
  };

  try {
    const apiUrl = process.env.REACT_APP_LABS_API;
    const response = await fetch(apiUrl + "OEC/usuario/get_user_sentForReview_true.php", requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Erro ao buscar os dados: ", error);
    throw error;
  }
}

export { get_user_sentForReview_true };
